<div class="filter-buttons-container" *ngIf="elementId">
  <button
    mat-icon-button
    class="button-position"
    (click)="grid.clearFilters()"
    [matTooltip]="'common.clear-grid-filter' | translate | lowercase"
  >
    <mat-icon class="material-icons-outlined" svgIcon="reset-grid"></mat-icon>
  </button>
  <wlm-export-excel-button
    [visibleColumns]="gridSettings?.gridColumnSettings"
    [grid]="grid"
  ></wlm-export-excel-button>

  <wlm-export-pdf-button [exportPdfComponent]="grid"></wlm-export-pdf-button>
</div>

<wlm-generic-grid
  *ngIf="elementId"
  class="wtr-fx-flex-grow"
  [gridSettings]="gridSettings"
  [gridFiltersForBinding]="filters"
>
</wlm-generic-grid>
